const messageKey = message => message && String(message.client_msg_id || message.id);

export default {
  data() {
    return { windowheight: 0, viewportTop: 0, scrollAffix: false, historyAnchor: null,
      viewportFrame: null, mobileLayoutEpoch: 0, mobileVisibleUid: null,
      mobileReadingPosition: null, mobilePendingPosition: null, mobileDisposed: false };
  },
  computed: {
    mobileMessagesVisible() {
      return !!this.historyConversation.uid && this.mobileVisibleUid == this.historyConversation.uid;
    },
  },
  methods: {
    scrollContainer() {
      const scrollbar = this.$refs.scrollbarRef;
      return scrollbar && scrollbar.$el.querySelector('.el-scrollbar__wrap');
    },
    readMobilePosition(following = !this.scrollAffix) {
      const container = this.scrollContainer();
      if (!container) return null;
      const top = container.getBoundingClientRect().top;
      const node = Array.from(container.querySelectorAll('[data-chat-message-id]'))
        .find(item => item.getBoundingClientRect().bottom > top);
      return { top: container.scrollTop, following,
        anchor: node ? { id: node.getAttribute('data-chat-message-id'), offset: node.getBoundingClientRect().top - top } : null };
    },
    rememberMobilePosition(address = this.historyConversation.uid) {
      if (!address || this.mobileVisibleUid != address || !this.mobileReadingPosition) return;
      this.$store.commit('rememberMobileChatPosition', { address, position: this.mobileReadingPosition });
    },
    cancelMobileLayout() {
      this.mobileLayoutEpoch++;
      if (this.viewportFrame !== null) cancelAnimationFrame(this.viewportFrame);
      this.viewportFrame = null;
      this.mobilePendingPosition = null;
    },
    queueMobileLayout(position = this.mobilePendingPosition || this.mobileReadingPosition) {
      this.cancelMobileLayout();
      const epoch = this.mobileLayoutEpoch;
      const uid = this.historyConversation.uid;
      this.mobilePendingPosition = position;
      this.$nextTick(() => {
        if (this.mobileDisposed || epoch !== this.mobileLayoutEpoch || this.historyConversation.uid != uid) return;
        this.viewportFrame = requestAnimationFrame(() => {
          if (this.mobileDisposed || epoch !== this.mobileLayoutEpoch || this.historyConversation.uid != uid) return;
          this.viewportFrame = null;
          this.mobilePendingPosition = null;
          const container = this.scrollContainer();
          if (!container) return;
          const scrollbar = this.$refs.scrollbarRef;
          if (scrollbar.update) scrollbar.update();
          this.scrollAffix = !!position && position.following === false;
          let top = position && position.top;
          if (!this.scrollAffix) top = container.scrollHeight - container.clientHeight;
          else if (position.anchor) {
            const node = Array.from(container.querySelectorAll('[data-chat-message-id]'))
              .find(item => item.getAttribute('data-chat-message-id') === position.anchor.id);
            if (node) top = container.scrollTop + node.getBoundingClientRect().top
              - container.getBoundingClientRect().top - position.anchor.offset;
          }
          container.scrollTop = Math.max(0, Math.min(top || 0, container.scrollHeight - container.clientHeight));
          this.mobileVisibleUid = uid;
          this.mobileReadingPosition = this.readMobilePosition();
          this.rememberMobilePosition();
          this.loadMobileHistoryIfNeeded();
        });
      });
    },
    refreshMobileView() {
      const user = this.historyConversation;
      if (user.uid && (user.historyLoaded === true || user.historyError)) this.queueMobileLayout();
    },
    loadMobileHistoryIfNeeded(fromScroll = false) {
      const user = this.historyConversation;
      const container = this.scrollContainer();
      if (this.mobileDisposed || !this.mobileMessagesVisible || !container || !container.clientHeight || !this.chatReady ||
          user.historyLoaded !== true || user.historyLoading || user.syncingHistory || user.historyError ||
          user.hasMoreHistory === false) return;
      if (container.scrollHeight <= container.clientHeight + 1 || (fromScroll && container.scrollTop <= 120)) {
        return this.queryHistory();
      }
    },
    chatwindowscrollevent() {
      const container = this.scrollContainer();
      if (!container || !this.mobileMessagesVisible || this.viewportFrame !== null) return;
      this.scrollAffix = container.scrollHeight - container.scrollTop - container.clientHeight > 50;
      this.mobileReadingPosition = this.readMobilePosition();
      this.rememberMobilePosition();
      this.loadMobileHistoryIfNeeded(true);
    },
    scrollToBottomImmediate() { this.queueMobileLayout({ following: true }); },
    handleImageLoad() {
      if (this.mobileMessagesVisible) this.queueMobileLayout(this.mobilePendingPosition || this.mobileReadingPosition);
    },
    handleViewportResize() {
      const viewport = window.visualViewport;
      this.windowheight = viewport ? viewport.height : document.documentElement.clientHeight;
      this.viewportTop = viewport ? viewport.offsetTop : 0;
      this.handleImageLoad();
    },
    captureHistoryPosition() {
      this.historyAnchor = { uid: this.historyConversation.uid, position: this.readMobilePosition() };
    },
  },
  watch: {
    messages: {
      handler(messages, previous = []) {
        if (!this.mobileMessagesVisible) { this.refreshMobileView(); return; }
        const position = this.readMobilePosition();
        const first = messageKey(previous[0]);
        if (first && messages.findIndex(message => messageKey(message) === first) > 0) {
          this.historyAnchor = null;
          this.queueMobileLayout(position);
          return;
        }
        const keys = new Set(previous.map(messageKey));
        const latestId = previous.reduce((id, message) => Math.max(id, Number(message.id) || 0), 0);
        const outgoing = messages.some(message => message.sender_id == this.$store.state.User.id &&
          !keys.has(messageKey(message)) && (!Number(message.id) || Number(message.id) > latestId));
        this.queueMobileLayout(outgoing ? { following: true } : position);
      },
    },
    'historyConversation.uid': {
      immediate: true,
      handler(uid, previousUid) {
        this.rememberMobilePosition(previousUid);
        this.cancelMobileLayout();
        this.mobileVisibleUid = null;
        this.historyAnchor = null;
        this.mobileReadingPosition = this.historyConversation.mobileScrollPosition || null;
        this.scrollAffix = !!this.mobileReadingPosition && this.mobileReadingPosition.following === false;
        this.refreshMobileView();
      },
    },
    'historyConversation.historyLoaded'() { this.refreshMobileView(); },
    'historyConversation.historyError'() { this.refreshMobileView(); },
    'historyConversation.historyLoading'(loading) { if (!loading) this.refreshMobileView(); },
    'historyConversation.syncingHistory'(syncing) { if (!syncing) this.refreshMobileView(); },
    chatReady(ready) { if (ready) this.refreshMobileView(); },
  },
  mounted() {
    this.ensureRecentHistory();
    this.refreshMobileView();
    this.handleViewportResize();
    window.addEventListener('resize', this.handleViewportResize);
    window.addEventListener('orientationchange', this.handleViewportResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleViewportResize);
      window.visualViewport.addEventListener('scroll', this.handleViewportResize);
    }
  },
  beforeUnmount() {
    this.rememberMobilePosition();
    this.mobileDisposed = true;
    this.cancelMobileLayout();
    window.removeEventListener('resize', this.handleViewportResize);
    window.removeEventListener('orientationchange', this.handleViewportResize);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleViewportResize);
      window.visualViewport.removeEventListener('scroll', this.handleViewportResize);
    }
  },
};
